import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { ListItemIcon, ListItemText, Divider, Collapse, List, MenuItem, Popper, Paper, MenuList, Box, Tooltip, ListItemButton } from '@mui/material';
import {
  HomeOutlined, ExpandLess, ExpandMore,
  TrendingUpOutlined, CampaignOutlined, InsightsOutlined, AccountBalanceWalletOutlined, NewspaperOutlined, QuizOutlined,
  CloseOutlined, PeopleAltOutlined, ConfirmationNumberOutlined,
  LocationOnOutlined, SettingsOutlined,
  LocalOfferOutlined,
  PointOfSaleOutlined,
  DesignServicesOutlined,
  PersonOutlineOutlined,
  ArrowBackOutlined,
  StoreOutlined,
  AssignmentIndOutlined,
  Inventory2Outlined,
  QrCodeScannerOutlined,
  ShareOutlined,
  PendingActionsOutlined
} from '@mui/icons-material';
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ScannerApkModal from '../modales/ScannerApkModal';

const floatingMenuItemSx = {
  color: "#4B4D63",
  fontSize: "14px",
  fontFamily: "Bricolage Grotesque",
  textDecoration: "none",
  borderRadius: '6px',
  mx: 0.5,
  px: 1.5,
  py: 0.75,
  '&:hover': {
    backgroundColor: 'rgba(11, 0, 98, 0.06)',
    color: '#0b0062',
    '& .MuiListItemIcon-root': {
      color: '#0b0062',
    },
  },
};

const collapsedTooltipSx = {
  tooltip: {
    sx: {
      backgroundColor: '#ffffff',
      color: '#9496aa',
      fontSize: '12px',
      fontFamily: 'Bricolage Grotesque',
      textTransform: 'uppercase',
      fontWeight: 600,
      boxShadow: '0px 8px 24px rgba(11, 0, 98, 0.12), 0px 2px 8px rgba(0,0,0,0.08)',
      border: '1px solid rgba(75, 77, 99, 0.1)',
      borderRadius: '6px',
      px: 1.5,
      py: 0.75,
    }
  },
};

const EventMenu = ({ eventoId, userRole, toggleDrawer, setQROption, closeMenus, drawerOpen, expandedMenus, toggleExpandMenu, eventoActual, keepDrawerOpen = true, isMobile, collapse }) => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const currentPath = location.pathname;

  const [scannerModalOpen, setScannerModalOpen] = useState(false);
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const closeTimerRef = useRef(null);

  const isActive = (path) => currentPath === path;
  const isPathActive = (path) => currentPath === path || currentPath.startsWith(path + '/');

  const isExpandedMenuActive = (menuKey) => {
    switch (menuKey) {
      case "menu-data":
        return isActive(`/eventos/${eventoId}/tarifas`) ||
          isActive(`/eventos/${eventoId}/ubicaciones`) ||
          isActive(`/eventos/${eventoId}/editar`) ||
          isActive(`/eventos/${eventoId}/impresion`) ||
          isActive(`/eventos/${eventoId}/publicaciones`) ||
          isActive(`/eventos/${eventoId}/preguntas-frecuentes`) ||
          isActive(`/eventos/${eventoId}/cuentas`);
      case "menu-sales":
        return isPathActive(`/eventos/${eventoId}/ventas`) ||
          isPathActive(`/eventos/${eventoId}/solicitudes`) ||
          isPathActive(`/eventos/${eventoId}/tickets`) ||
          isPathActive(`/eventos/${eventoId}/vouchers`);
      case "menu-marketing":
        return isPathActive(`/eventos/${eventoId}/canales`) ||
          isActive(`/eventos/${eventoId}/meta-pixel`);
      case "menu-pos":
        return isActive(`/eventos/${eventoId}/caja-stock`) ||
          isActive(`/eventos/${eventoId}/venta-presencial`) ||
          isActive(`/eventos/${eventoId}/ventas-caja`) ||
          isActive(`/eventos/${eventoId}/caja-resumen`);
      default:
        return false;
    }
  };

  const handleExpandableMenuClick = (menuKey) => {
    toggleExpandMenu(menuKey);
  };

  useEffect(() => {
    if (!drawerOpen) return;
    if (isExpandedMenuActive("menu-data") && !expandedMenus["menu-data"]) toggleExpandMenu("menu-data");
    if (isExpandedMenuActive("menu-sales") && !expandedMenus["menu-sales"]) toggleExpandMenu("menu-sales");
    if (isExpandedMenuActive("menu-marketing") && !expandedMenus["menu-marketing"]) toggleExpandMenu("menu-marketing");
    if (isExpandedMenuActive("menu-pos") && !expandedMenus["menu-pos"]) toggleExpandMenu("menu-pos");
  }, [currentPath, drawerOpen]);

  useEffect(() => {
    return () => { if (closeTimerRef.current) clearTimeout(closeTimerRef.current); };
  }, []);

  const closeAllExpandedMenus = () => {
    ["menu-data", "menu-sales", "menu-marketing", "menu-pos"].forEach(menuKey => {
      const shouldBeOpen = isExpandedMenuActive(menuKey);
      if (expandedMenus[menuKey] !== shouldBeOpen) toggleExpandMenu(menuKey);
    });
  };


  const iconSx = { minWidth: collapse ? 0 : "40px", justifyContent: 'center' };
  const itemSx = (extra = {}) => ({
    color: "#4B4D63",
    textDecoration: "none",
    justifyContent: collapse ? 'center' : 'flex-start',
    px: collapse ? 0 : undefined,
    ...extra,
  });

  const handleItemClick = (customAction) => {
    if (isMobile) {
      closeMenus();
      if (typeof window !== "undefined") window.localStorage.setItem("drawerClosedManually", "true");
    }
    closeAllExpandedMenus();
    if (customAction && typeof customAction === 'function') customAction();
  };

  const closeHoverMenu = () => {
    setHoveredMenu(null);
    setMenuAnchorEl(null);
  };

  const handleMenuHoverOpen = (event, menuKey) => {
    if (!collapse) return;
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    setHoveredMenu(menuKey);
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuHoverClose = () => {
    closeTimerRef.current = setTimeout(closeHoverMenu, 100);
  };

  const handleFloatingMenuEnter = () => {
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
  };



  return (
    <>
      {/* INICIO PASSGO */}
      <Tooltip title={collapse ? t("navbar.home") : ""} placement="right" componentsProps={collapsedTooltipSx}>
        <ListItemButton component={Link} to="/" onClick={() => handleItemClick()} className="drawer-item" sx={itemSx()}>
          <ListItemIcon sx={iconSx}><HomeOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
          {!collapse && (
            <ListItemText primary={t("navbar.home")} primaryTypographyProps={{
              fontFamily: "Bricolage Grotesque",
              sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/`) ? 600 : 400 }
            }} />
          )}
        </ListItemButton>
      </Tooltip>

      {/* HOME - DASHBOARD */}
      {userRole !== 3 && userRole !== 8 && userRole !== 9 && (
        <Tooltip title={collapse ? "Panel de control" : ""} placement="right" componentsProps={collapsedTooltipSx}>
          <ListItemButton component={Link} to={`/eventos/${eventoId}`} onClick={() => handleItemClick()} className="drawer-item" sx={itemSx()}>
            <ListItemIcon sx={iconSx}><TrendingUpOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
            {!collapse && (
              <ListItemText primary="Panel de control" primaryTypographyProps={{
                fontFamily: "Bricolage Grotesque",
                sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}`) ? 600 : 400 }
              }} />
            )}
          </ListItemButton>
        </Tooltip>
      )}

      {/* CONFIGURACIÓN DEL EVENTO */}
      {userRole !== 5 && userRole !== 3 && userRole !== 6 && userRole !== 7 && userRole !== 8 && userRole !== 9 && userRole !== 10 && eventoActual?.id_estados_eventos !== 4 && (
        <>
          <ListItemButton
            onClick={() => { if (!collapse) handleExpandableMenuClick("menu-data"); }}
            onMouseEnter={(e) => handleMenuHoverOpen(e, "menu-data")}
            onMouseLeave={handleMenuHoverClose}
            className="drawer-item"
            sx={itemSx({ backgroundColor: isExpandedMenuActive("menu-data") ? 'rgba(11, 0, 98, 0.08)' : 'transparent' })}
          >
            <ListItemIcon sx={iconSx}>
              <SettingsOutlined style={{ color: "#4B4D63", fontWeight: isExpandedMenuActive("menu-data") ? 600 : 400 }} />
            </ListItemIcon>
            {!collapse && (
              <>
                <ListItemText primary="Configuración del evento" primaryTypographyProps={{
                  fontFamily: "Bricolage Grotesque",
                  sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isExpandedMenuActive("menu-data") ? 600 : 400 }
                }} />
                {expandedMenus["menu-data"] ? <ExpandLess style={{ color: "#4B4D63" }} /> : <ExpandMore style={{ color: "#4B4D63" }} />}
              </>
            )}
          </ListItemButton>

          <Collapse in={expandedMenus["menu-data"] && !collapse} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userRole !== 2 && userRole !== 5 && userRole !== 6 && eventoActual?.privado !== true && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/publicaciones`} onClick={() => handleItemClick()} sx={{ pl: 4 }} className="drawer-item">
                  <ListItemIcon sx={{ minWidth: "40px" }}><NewspaperOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary={t("menuTemplate.publications")} primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/publicaciones`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
              {userRole !== 2 && userRole !== 5 && userRole !== 6 && eventoActual?.privado !== true && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/preguntas-frecuentes`} onClick={() => handleItemClick()} sx={{ pl: 4 }} className="drawer-item">
                  <ListItemIcon sx={{ minWidth: "40px" }}><QuizOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary="Preguntas frecuentes" primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/preguntas-frecuentes`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
              {userRole === 1 && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/editar`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                  <ListItemIcon sx={{ minWidth: "40px" }}><SettingsOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary={t("menuTemplate.eventConfiguration")} primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/editar`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
              {userRole === 1 && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/tarifas`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                  <ListItemIcon sx={{ minWidth: "40px" }}><LocalOfferOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary="Entradas y precios" primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/tarifas`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
              {userRole === 1 && !isMobile && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/ubicaciones`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                  <ListItemIcon sx={{ minWidth: "40px" }}><LocationOnOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary="Ubicaciones" primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/ubicaciones`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
              {(userRole === 1 || userRole === 7) && !isMobile && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/impresion`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                  <ListItemIcon sx={{ minWidth: "40px" }}><DesignServicesOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary="Diseño de tickets" primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/impresion`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
              {userRole === 1 && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/cuentas`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                  <ListItemIcon sx={{ minWidth: "40px" }}><AccountBalanceWalletOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary="Cobros y pagos" primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/cuentas`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )}

      {/* VENTAS Y CONTROL */}
      {userRole !== 5 && userRole !== 6 && userRole !== 8 && userRole !== 9 && userRole !== 10 && (
        <>
          <ListItemButton
            onClick={() => { if (!collapse) handleExpandableMenuClick("menu-sales"); }}
            onMouseEnter={(e) => handleMenuHoverOpen(e, "menu-sales")}
            onMouseLeave={handleMenuHoverClose}
            className="drawer-item"
            sx={itemSx()}
          >
            <ListItemIcon sx={iconSx}>
              <PointOfSaleOutlined style={{ color: "#4B4D63", fontWeight: isExpandedMenuActive("menu-sales") ? 600 : 400 }} />
            </ListItemIcon>
            {!collapse && (
              <>
                <ListItemText primary="Ventas y Control" primaryTypographyProps={{
                  fontFamily: "Bricolage Grotesque",
                  sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isExpandedMenuActive("menu-sales") ? 600 : 400 }
                }} />
                {expandedMenus["menu-sales"] ? <ExpandLess style={{ color: "#4B4D63" }} /> : <ExpandMore style={{ color: "#4B4D63" }} />}
              </>
            )}
          </ListItemButton>

          <Collapse in={expandedMenus["menu-sales"] && !collapse} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userRole !== 2 && userRole !== 5 && userRole !== 6 && userRole !== 7 && userRole !== 9 && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/ventas`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                  <ListItemIcon sx={{ minWidth: "40px" }}><TrendingUpOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary="Ventas realizadas" primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isPathActive(`/eventos/${eventoId}/ventas`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
              {userRole === 1 && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/solicitudes`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                  <ListItemIcon sx={{ minWidth: "40px" }}><PendingActionsOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary="Solicitudes de tickets" primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isPathActive(`/eventos/${eventoId}/solicitudes`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
              {userRole !== 9 && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/tickets`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                  <ListItemIcon sx={{ minWidth: "40px" }}><ConfirmationNumberOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary="Tickets" primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isPathActive(`/eventos/${eventoId}/tickets`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
              {userRole !== 9 && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/vouchers`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                  <ListItemIcon sx={{ minWidth: "40px" }}><LocalOfferOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary="Vouchers" primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isPathActive(`/eventos/${eventoId}/vouchers`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )}

      {/* MARKETING */}
      {(userRole === 1 || userRole === 3) && (
        <>
          <ListItemButton
            onClick={() => { if (!collapse) handleExpandableMenuClick("menu-marketing"); }}
            onMouseEnter={(e) => handleMenuHoverOpen(e, "menu-marketing")}
            onMouseLeave={handleMenuHoverClose}
            className="drawer-item"
            sx={itemSx({ backgroundColor: isExpandedMenuActive("menu-marketing") ? 'rgba(11, 0, 98, 0.08)' : 'transparent' })}
          >
            <ListItemIcon sx={iconSx}>
              <CampaignOutlined style={{ color: "#4B4D63" }} />
            </ListItemIcon>
            {!collapse && (
              <>
                <ListItemText primary="Marketing" primaryTypographyProps={{
                  fontFamily: "Bricolage Grotesque",
                  sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isExpandedMenuActive("menu-marketing") ? 600 : 400 }
                }} />
                {expandedMenus["menu-marketing"] ? <ExpandLess style={{ color: "#4B4D63" }} /> : <ExpandMore style={{ color: "#4B4D63" }} />}
              </>
            )}
          </ListItemButton>

          <Collapse in={expandedMenus["menu-marketing"] && !collapse} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton component={Link} to={`/eventos/${eventoId}/canales`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                <ListItemIcon sx={{ minWidth: "40px" }}><ShareOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                <ListItemText primary="Canales de venta" primaryTypographyProps={{
                  fontFamily: "Bricolage Grotesque",
                  sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isPathActive(`/eventos/${eventoId}/canales`) ? 600 : 400 }
                }} />
              </ListItemButton>
              {userRole === 1 && (
                <ListItemButton component={Link} to={`/eventos/${eventoId}/meta-pixel`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                  <ListItemIcon sx={{ minWidth: "40px" }}><InsightsOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary="Meta Pixel" primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/meta-pixel`) ? 600 : 400 }
                  }} />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )}

      {/* PUNTO DE VENTA */}
      {userRole !== 5 && userRole !== 6 && userRole !== 8 && eventoActual?.id_estados_eventos !== 4 && (
        <>
          {(userRole === 1 || userRole === 10) ? (
            <>
              <ListItemButton
                onClick={() => { if (!collapse) handleExpandableMenuClick("menu-pos"); }}
                onMouseEnter={(e) => handleMenuHoverOpen(e, "menu-pos")}
                onMouseLeave={handleMenuHoverClose}
                className="drawer-item"
                sx={itemSx({ backgroundColor: isExpandedMenuActive("menu-pos") ? 'rgba(11, 0, 98, 0.08)' : 'transparent' })}
              >
                <ListItemIcon sx={iconSx}>
                  <StoreOutlined style={{ color: "#4B4D63", fontWeight: isExpandedMenuActive("menu-pos") ? 600 : 400 }} />
                </ListItemIcon>
                {!collapse && (
                  <>
                    <ListItemText primary="Punto de Venta" primaryTypographyProps={{
                      fontFamily: "Bricolage Grotesque",
                      sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isExpandedMenuActive("menu-pos") ? 600 : 400 }
                    }} />
                    {expandedMenus["menu-pos"] ? <ExpandLess style={{ color: "#4B4D63" }} /> : <ExpandMore style={{ color: "#4B4D63" }} />}
                  </>
                )}
              </ListItemButton>

              <Collapse in={expandedMenus["menu-pos"] && !collapse} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton component={Link} to={`/eventos/${eventoId}/caja`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                    <ListItemIcon sx={{ minWidth: "40px" }}><AssignmentIndOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                    <ListItemText primary="Caja" primaryTypographyProps={{
                      fontFamily: "Bricolage Grotesque",
                      sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/caja`) ? 600 : 400 }
                    }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to={`/eventos/${eventoId}/stock`} sx={{ pl: 4 }} onClick={() => handleItemClick()} className="drawer-subitem">
                    <ListItemIcon sx={{ minWidth: "40px" }}><Inventory2Outlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                    <ListItemText primary="Stock" primaryTypographyProps={{
                      fontFamily: "Bricolage Grotesque",
                      sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/stock`) ? 600 : 400 }
                    }} />
                  </ListItemButton>
                </List>
              </Collapse>
            </>
          ) : (
            <></>
          )}
        </>
      )}

      {/* STAFF Y COLABORADORES ACCESOS */}
      {userRole !== 5 && userRole !== 6 && userRole !== 7 && userRole !== 8 && userRole !== 9 && userRole !== 10 && (
        <>
          <Tooltip title={collapse ? "Accesos" : ""} placement="right" componentsProps={collapsedTooltipSx}>
            <ListItemButton component={Link} to={`/eventos/${eventoId}/colaboradores-accesos`} onClick={() => handleItemClick()} className="drawer-item" sx={itemSx()}>
              <ListItemIcon sx={iconSx}><QrCodeScannerOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
              {!collapse && (
                <ListItemText primary="Accesos" primaryTypographyProps={{
                  fontFamily: "Bricolage Grotesque",
                  sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/colaboradores-accesos`) ? 600 : 400 }
                }} />
              )}
            </ListItemButton>
          </Tooltip>
          <Tooltip title={collapse ? "Colaboradores" : ""} placement="right" componentsProps={collapsedTooltipSx}>
            <ListItemButton component={Link} to={`/eventos/${eventoId}/staff`} onClick={() => handleItemClick()} className="drawer-item" sx={itemSx()}>
              <ListItemIcon sx={iconSx}><PeopleAltOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
              {!collapse && (
                <ListItemText primary="Colaboradores" primaryTypographyProps={{
                  fontFamily: "Bricolage Grotesque",
                  sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/staff`) ? 600 : 400 }
                }} />
              )}
            </ListItemButton>
          </Tooltip>
        </>
      )}

      {userRole === 8 && (
        <Tooltip title={collapse ? "Asistentes" : ""} placement="right" componentsProps={collapsedTooltipSx}>
          <ListItemButton component={Link} to={`/eventos/${eventoId}/mis-asistentes`} onClick={() => handleItemClick()} className="drawer-item" sx={itemSx()}>
            <ListItemIcon sx={iconSx}><PersonOutlineOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
            {!collapse && (
              <ListItemText primary="Asistentes" primaryTypographyProps={{
                fontFamily: "Bricolage Grotesque",
                sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos/${eventoId}/mis-asistentes`) ? 600 : 400 }
              }} />
            )}
          </ListItemButton>
        </Tooltip>
      )}

      {!collapse && (
        <>
          <Divider sx={{ backgroundColor: '#4b4d63', width: '100%', marginBottom: '10px', marginTop: '20px' }} />
          <ListItemButton
            onClick={() => {
              if (isMobile) {
                if (typeof window !== "undefined") window.localStorage.setItem("drawerClosedManually", "true");
              }
              toggleDrawer();
            }}
            sx={itemSx({ marginTop: "10px", cursor: "pointer" })}
            className="drawer-item"
          >
            <ListItemIcon sx={iconSx}><CloseOutlined style={{ color: "#4b4d63" }} /></ListItemIcon>
            <ListItemText primary="Ocultar menú" primaryTypographyProps={{
              fontFamily: "Bricolage Grotesque",
              sx: { fontSize: "14px", color: "#4B4D63" }
            }} />
          </ListItemButton>
        </>
      )}

      {collapse && (
        <Divider sx={{ backgroundColor: '#4b4d63', width: '100%', marginBottom: '10px', marginTop: '20px' }} />
      )}
      <Tooltip title={collapse ? "Mis eventos" : ""} placement="right" componentsProps={collapsedTooltipSx}>
        <ListItemButton component={Link} to="/eventos" onClick={() => handleItemClick()} className="drawer-item" sx={itemSx()}>
          <ListItemIcon sx={iconSx}><ArrowBackOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
          {!collapse && (
            <ListItemText primary="Mis eventos" primaryTypographyProps={{
              fontFamily: "Bricolage Grotesque",
              sx: { fontSize: "14px", color: "#4B4D63", fontWeight: 400 }
            }} />
          )}
        </ListItemButton>
      </Tooltip>

      {/* MENU FLOTANTE */}
      <Popper
        open={Boolean(hoveredMenu)}
        anchorEl={menuAnchorEl}
        placement="right-start"
        style={{ zIndex: 1300 }}
        modifiers={[{ name: 'offset', options: { offset: [-8, 8] } }]}
      >
        <Paper
          onMouseEnter={handleFloatingMenuEnter}
          onMouseLeave={handleMenuHoverClose}
          sx={{
            minWidth: 230,
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            boxShadow: '0px 8px 24px rgba(11, 0, 98, 0.12), 0px 2px 8px rgba(0,0,0,0.08)',
            border: '1px solid rgba(75, 77, 99, 0.1)',
            overflow: 'hidden',
            py: 0.5,
          }}
        >
          {/* ENCABEZADO */}
          <Box sx={{
            px: 2,
            py: 1,
            borderBottom: '1px solid rgba(75, 77, 99, 0.08)',
            mb: 0.5,
          }}>
            <span style={{
              fontSize: '11px',
              fontFamily: 'Bricolage Grotesque',
              fontWeight: 600,
              color: '#9496aa',
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
            }}>
              {hoveredMenu === "menu-data" && "Configuración"}
              {hoveredMenu === "menu-sales" && "Ventas y Control"}
              {hoveredMenu === "menu-marketing" && "Marketing"}
              {hoveredMenu === "menu-pos" && "Punto de Venta"}
            </span>
          </Box>

          <MenuList disablePadding sx={{ py: 0.5 }}>
            {/* CONFIGURACION */}
            {hoveredMenu === "menu-data" && userRole !== 2 && userRole !== 5 && userRole !== 6 && eventoActual?.privado !== true && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/publicaciones`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><NewspaperOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                {t("menuTemplate.publications")}
              </MenuItem>
            )}
            {hoveredMenu === "menu-data" && userRole !== 2 && userRole !== 5 && userRole !== 6 && eventoActual?.privado !== true && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/preguntas-frecuentes`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><QuizOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Preguntas frecuentes
              </MenuItem>
            )}
            {hoveredMenu === "menu-data" && userRole === 1 && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/editar`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><SettingsOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                {t("menuTemplate.eventConfiguration")}
              </MenuItem>
            )}
            {hoveredMenu === "menu-data" && userRole === 1 && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/tarifas`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><LocalOfferOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Entradas y precios
              </MenuItem>
            )}
            {hoveredMenu === "menu-data" && userRole === 1 && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/ubicaciones`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><LocationOnOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Ubicaciones
              </MenuItem>
            )}
            {hoveredMenu === "menu-data" && (userRole === 1 || userRole === 7) && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/impresion`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><DesignServicesOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Diseño de tickets
              </MenuItem>
            )}
            {hoveredMenu === "menu-data" && userRole === 1 && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/cuentas`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><AccountBalanceWalletOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Cobros y pagos
              </MenuItem>
            )}

            {/* VENTAS */}
            {hoveredMenu === "menu-sales" && userRole !== 2 && userRole !== 5 && userRole !== 6 && userRole !== 7 && userRole !== 9 && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/ventas`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><TrendingUpOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Ventas realizadas
              </MenuItem>
            )}
            {hoveredMenu === "menu-sales" && userRole === 1 && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/solicitudes`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><PendingActionsOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Solicitudes de tickets
              </MenuItem>
            )}
            {hoveredMenu === "menu-sales" && userRole !== 9 && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/tickets`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><ConfirmationNumberOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Tickets
              </MenuItem>
            )}
            {hoveredMenu === "menu-sales" && userRole !== 9 && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/vouchers`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><LocalOfferOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Vouchers
              </MenuItem>
            )}

            {/* MARKETING */}
            {hoveredMenu === "menu-marketing" && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/canales`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><ShareOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Canales de venta
              </MenuItem>
            )}
            {hoveredMenu === "menu-marketing" && userRole === 1 && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/meta-pixel`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><InsightsOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Meta Pixel
              </MenuItem>
            )}

            {/* PUNTO DE VENTA */}
            {hoveredMenu === "menu-pos" && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/caja`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><AssignmentIndOutlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Caja
              </MenuItem>
            )}
            {hoveredMenu === "menu-pos" && (
              <MenuItem component={Link} to={`/eventos/${eventoId}/stock`} onClick={closeHoverMenu} sx={floatingMenuItemSx}>
                <ListItemIcon sx={{ minWidth: "36px" }}><Inventory2Outlined fontSize="small" style={{ color: "#4B4D63" }} /></ListItemIcon>
                Stock
              </MenuItem>
            )}
          </MenuList>
        </Paper>
      </Popper>

      <ScannerApkModal
        open={scannerModalOpen}
        handleClose={() => { setScannerModalOpen(false); }}
      />
    </>
  );
};

export default EventMenu;